import Error from '@components/error/Error';
import ScrollToTop from '@components/scroll-to-top/ScrollToTop';
import useRouter from '@hooks/useRouter';
import FullCenter from '@layouts/full-center/FullCenter';
import type { AppRoute } from '@routes';
import routes from '@routes';
import Protected from '@ui/components/protected/Protected';
import { useStyles } from '@ui/utils/makeStyles';
import React, { Suspense } from 'react';
import { Navigate } from 'react-router';

interface AppPageProps {
  route: AppRoute
}

const AppPage = (props: AppPageProps) => {
  const { theme } = useStyles();
  const router = useRouter();
  const { route } = props;
  const {
    Page,
    roles, // if a route has no roles, consider it public
  } = route;

  const Layout = route?.Layout as unknown as any;

  return (
    <Protected
      allowedRoles={roles}
      renderUnauthorized={(isLoggedIn) => {
        if (isLoggedIn) {
          return (
            <>
              <ScrollToTop />
              <FullCenter style={{ padding: theme.spacing(2) }}>
                <Error
                  statusCode="404"
                />
              </FullCenter>
            </>
          );
        }

        return (
          <Navigate
            to={routes.login.path}
            state={{ next: router.location.pathname }}
          />
        );
      }}
    >
      <ScrollToTop />
      <Layout>
        <Suspense
          fallback={null}
        >
          <Page />
        </Suspense>
      </Layout>
    </Protected>
  );
};

export default React.memo(AppPage);
